import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'replaceWith',
})
export class ReplaceWithPipe implements PipeTransform {
  transform(value: string, newValue: string, replaceIf: boolean): string {
    if (replaceIf) return newValue;
    return value;
  }
}
